import {
	getListSpacesQueryKey,
	getListSpacesQueryOptions,
	listSpaces,
} from '@cocoonspace/sdk-js/domains/spaces/spaces'
import { defaultI18nNs } from '@cocoonspace/shared/config/default-i-18-n-ns-config'
import { QueryClient, dehydrate } from '@tanstack/react-query'
import type { GetStaticPropsContext } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import type { Zone } from '@cocoonspace/sdk-js/types/zone'
import { select } from '~/domains/search/config/select-api-keys'
import { LandingZonePage } from '~/domains/spaces/components/pages/landing-zone-page'

const Page = () => <LandingZonePage landingPrefix='hourlyOffices' />

export default Page

export const getStaticProps = async ({
	params,
	locale,
}: GetStaticPropsContext) => {
	const queryClient = new QueryClient()
	const zone = (params?.zone as Zone) || 'paris'

	try {
		await queryClient.fetchQuery(getListSpacesQueryOptions({ zone, select }))

		return {
			props: {
				...(await serverSideTranslations(locale as string, [
					...defaultI18nNs,
					'cwLandings',
				])),
				dehydratedState: dehydrate(queryClient),
			},
			revalidate: 24 * 60 * 60, // 24h
		}
	} catch (e) {
		return { notFound: true }
	}
}

export const getStaticPaths = async () => {
	return {
		paths: [{ params: { zone: 'paris' } }, { params: { zone: 'lyon' } }],
		fallback: false,
	}
}
